export const ACCEPTED_FILE_MIME_TYPES = [
	'image/jpeg',
	'image/png',
	'image/jpg',
	'image/webp',
	'application/pdf'
];

export const ACCEPTED_FILE_DROPZONE_TYPES = {
	'image/jpeg': ['.jpg', '.jpeg'],
	'image/png': ['.png'],
	'image/webp': ['.webp'],
	'application/pdf': ['.pdf']
};

export const MAX_FILE_SIZE_BYTES = 20 * 1024 * 1024;

export const MAX_PATIENT_DOCUMENTS_FILES = 5;

export const MAX_PATIENT_DOCUMENT_FILE = 1;
